import { Trans } from '@lingui/react/macro';

import FileUpload from '@/components/FileUpload';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import IconReceipt from '@/icons/Receipt.svg';

import { useInvoiceContext } from '../Invoice';

export const InvoicePaymentReceipt = () => {
  const { invoice, isDisabled } = useInvoiceContext();

  if (invoice.paymentStrategy !== 'store-cash-out') {
    return null;
  }

  const paymentReceipts = invoice.media.filter((medium) => medium.type === 'payment-receipt');

  if (isDisabled && !paymentReceipts.length) {
    return null;
  }

  return (
    <FileUpload
      uploadData={{ type: 'payment-receipt', invoiceId: invoice.id }}
      media={paymentReceipts}
      disabled={isDisabled}
      deleteWithApi
      label={
        <>
          <Trans id="invoice.form.payment-receipt">Payment receipt</Trans>
          <OptionalLabel />
        </>
      }
      icon={<IconReceipt />}
      maxNumberOfMedia={1}
      withQrCode
    />
  );
};
